import { combineReducers } from 'redux'
import { createFullCycleHandlers } from 'utils/reducers'
import actions from 'actions/crm/verification'
import crmState from './initial.state'

export default combineReducers({
  settings: createFullCycleHandlers(actions.settings, crmState.verification.settings),
  labels: createFullCycleHandlers(actions.labels, crmState.verification.labels)
})
